exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#content {\n    background: unset !important;\n}\n\n#content .widthLimit {\n    padding: 0px 0px;\n    min-width: 1200px;\n}\n\n.error {\n    padding-top: 100px;\n    text-align: center;\n}\n/* 隐藏遮罩 */\n#loading {\n    display: none;\n}\n\n.error_msg {\n    font-size: 20px;\n    color: #333333;\n    margin-top: 20px;\n    line-height: 1.5;\n}\n\n/* 适配移动端 */\n@media (max-width: 768px) {\n    body, html, #content {\n        min-width: 0;\n        min-height: 0;\n    }\n\n    #content .widthLimit {\n        width: 100%;\n        max-width: 425px;\n        min-width: 0px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./public/hws/css/error.lazy.css
// module id = 205
// module chunks = 0